import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import Input from '../component/Input.js';
import Modal from 'react-modal';
import loader from '../asset/img/loader.gif';
import sparkles2 from '../asset/img/sparkles2.png';

export default class ManageYears extends Component {
	constructor(props){
		super(props);
		this.state = {newYear:{year:'',cap:'',sent:'',received:''},failed:false,modalPrompt:'',loading:false};
		this.handleCreate = this.handleCreate.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	handleCreate(identity,value){ //method for handling user input for each input field during year creation
		let pass = false;
		if(identity === "year" && value.toString().length <= 4){ //makes sure that year length is 4
			pass = true;
		}else if(identity === "cap" && value.toString().length <= 3){ //makes sure that point cap length for user points is 3
			pass = true;
		}else if(identity === "sent" && value.toString().length <= 2){ //makes sure that sent points length is 2
			pass = true;
		}else if(identity === "received" && value.toString().length <= 2){ //makes sure that received points length is 2
			pass = true;
		}
		if(pass && /^(\s*|[1-9][0-9]*)$/.test(value)){ //only allow blank input fields or positive integers
			let theState = this.state.newYear;
			theState[identity] = value;
			this.setState({newYear:theState});
		}
	}

	closeModal(){ //close the modal
		this.setState({modalIsOpen:false,modalPrompt:''});
		this.props.revertSave();
	}

	componentDidUpdate(prevProps){
		if(prevProps.save !== this.props.save && this.props.save){ //if user has chosen to save new year information
			const {newYear} = this.state;
			let d = new Date();
			let year = d.getFullYear();
			let failed = false;
			if(this.props.create && newYear.year !== '' && newYear.year !== 0 && newYear.year >= year  && newYear.cap!=='' && newYear.cap !==0 &&newYear.sent !== '' && newYear.sent !== 0 && newYear.received !== '' && newYear.received !==0){ //make sure all fields are filled out and that none of them equal 0
				this.setState({loading:true,modalIsOpen:true});
				axios({ //create new year information
					method:'post',
					url:path,headers:{'Content-Type':'application/json'},
					data:{endpoint:'create',table:'year',misc:'create',firstID:newYear.year,secondID:newYear.cap,thirdID:newYear.sent,quantity:newYear.received}
				}).then((response)=>{
						if(response.data.data.Message === "Year exists."){ //if year already exists, alert user
							this.setState({modalPrompt:'Year already exists.'},function(){
								this.setState({loading:false});
								document.getElementById("year").classList.add("invalid");
							});
						}else{ //clear inputs and alert user that year was successfully created
							this.props.reset("years");
							this.setState({newYear:{year:'',cap:'',sent:'',received:''},modalPrompt:'Year successfully created!'},function(){
								this.setState({loading:false});
							});
						}
				}).catch((error)=>{
					this.setState({modalPrompt:'There was a problem during creation. Please try again.'},function(){
						this.setState({loading:false});
					});
				});
			}else{
				let prompt = '';
				if(newYear.year === '' || newYear.cap==='' || newYear.sent ===''  || newYear.received === ''){ //validate fields and highlight the ones that are not filled out
					prompt += 'All Fields are required. ';
					if(newYear.year === '' || newYear.year <= year){
						document.getElementById("year").classList.add("invalid");
					}else{
						document.getElementById("year").classList.remove("invalid");
					}
					if(newYear.cap===''){
						document.getElementById("pointCap").classList.add("invalid");
					}else{
						document.getElementById("pointCap").classList.remove("invalid");
					}
					if(newYear.sent === ''){
						document.getElementById("sent").classList.add("invalid");
					}else{
						document.getElementById("sent").classList.remove("invalid");
					}
					if(newYear.received === ''){
						document.getElementById("received").classList.add("invalid");
					}else{
						document.getElementById("received").classList.remove("invalid");
					}
				}
				if(newYear.year <= year){ //validate year value
					prompt += 'Year is invalid. Please try again. ';
					document.getElementById("year").classList.add("invalid");
				}else{
					document.getElementById("year").classList.remove("invalid");
				}

				this.setState({modalPrompt:prompt},function(){
					this.setState({modalIsOpen:true});
				});
			}
		}
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    minWidth:'300px',
		    maxWidth:'400px',
		    minHeight:'200px',
		    maxHeight:'200px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px',
		    backgroundImage:'url('+sparkles2+')',
		    backgroundSize:'300px 200px',
		    backgroundRepeat:'no-repeat'
			},  
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		const {newYear} = this.state;
		let years;
		let pstyle = "fl w-25 f4";
		let create;
		const labelStyle = "mt2 b tr-ns mr3 pt1 navy";
		const divstyle = "fl w-100 mb4";
		const inputStyles = "pl1 h2 br2 bw1 w-70-ns w-100 shadow-2 ml1-ns";
		let modalContent;
		if(this.state.loading){ //display loading gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else{ //display message
			modalContent = <div>
												<div className="fl w-100 tr">
										  		<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
										  	</div>
										  	<div className="pt3">
													<p className="tc b f4 navy mt3">{this.state.modalPrompt}</p>
												</div>
											</div>;
		}
		if(!(this.props.edit || this.props.create)){ //display all years and their information
			years = this.props.years.map((years,i)=>{
				return <li className="fl w-100 bb b--light-silver" key={i}><p className="fl w-20 f4">Year: {years.year}</p><p className={pstyle}>Point Cap: {years.point_cap}</p><p className={pstyle}>Sent Points: {years.sent_points}</p><p className="fl w-30 f4">Received Points: {years.received_points}</p></li>;
			});
		}else if(this.props.create){ //display input fields for creating new year information
				years = 	[<li className="fl w-100" key={1}>
											<div className={divstyle}>
												<div className="fl w-40-ns w-100 tr-ns pt1"><label className={labelStyle}>Year:</label></div>
												<div className="fl w-60-ns w-100 tl"><Input identity="year" id="year" val={newYear.year} onInput={this.handleCreate} inputStyle={inputStyles} type="number"/></div>
											</div>
											<div className={divstyle}>
												<div className="fl w-40-ns w-100 tr-ns pt1"><label className={labelStyle}>Point Cap:</label></div>
												<div className="fl w-60-ns w-100 tl"><Input identity="cap" id="pointCap" val={newYear.cap} onInput={this.handleCreate} inputStyle={inputStyles} type="number"/></div>
											</div>
										</li>,
										<li className="fl w-100"  key={2}>
											<div className={divstyle}>
												<div className="fl w-40-ns w-100 tr-ns pt1"><label className={labelStyle}>Sent Points:</label></div>
												<div className="fl w-60-ns w-100 tl"><Input identity="sent" id="sent" val={newYear.sent} onInput={this.handleCreate} inputStyle={inputStyles} type="number"/></div>
											</div> 
											<div className={divstyle}>
												<div className="fl w-40-ns w-100 tr-ns pt1"><label className={labelStyle}>Received Points:</label></div>
												<div className="fl w-60-ns w-100 tl"><Input identity="received" id="received" val={newYear.received} onInput={this.handleCreate} inputStyle={inputStyles} type="number"/></div>
											</div>
										</li>];
		}
		return(
			<div style={{maxWidth:'700px',margin:'auto'}} className="w-90 center">
				<ul className="list">
					{years}
				</ul>
				<div className="pt2" style={{maxWidth:'500px',margin:'auto'}}>
					{create}
				</div>
				<div>
					<Modal
			          isOpen={this.state.modalIsOpen}
			          style={customStyles}
			          contentLabel="loading"
			          shouldCloseOnOverlayClick={false}
			          shouldCloseOnEsc={false}
			        >
			        {modalContent}
			        </Modal>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ManageYears.js